import { PlanCardData } from '@/components/plan-card'

/**
 * The live pricing ladder (monthly-only at launch — both price fields
 * carry the same value since the period toggle is hidden). Paid CTAs
 * carry a ?plan intent that signup stashes and the billing page honors
 * after onboarding. Storage plan values: standard / pro / team.
 *
 * Every signup starts with a free 14-day trial of the full Agency
 * experience — no credit card. The free tier still exists internally as
 * the post-trial fallback (5 resumes/month) but is not marketed here.
 */
export const pricingPlans: PlanCardData[] = [
  {
    planName: 'Standard',
    monthlyPrice: '$9',
    annualMonthlyPrice: '$9',
    priceUnit: 'per month',
    targetUser: 'Personal Use',
    url: '/signup?plan=standard',
    linkLabel: 'Start your free 14-day trial',
    description: 'For individual recruiters branding resumes every week.',
    featuresDescription: 'Standard includes:',
    features: [
      { text: 'Unlimited resumes' },
      { text: 'Customized header' },
      { text: 'Customized footer' },
      { text: 'Customized watermark' },
      { text: 'Customized candidate write-up' },
    ],
  },
  {
    badge: {
      text: 'Most Popular',
      color: 'primary',
    },
    planName: 'Pro',
    monthlyPrice: '$15',
    annualMonthlyPrice: '$15',
    priceUnit: 'per month',
    targetUser: 'Professional Use',
    url: '/signup?plan=pro',
    linkLabel: 'Start your free 14-day trial',
    highlighted: true,
    description:
      'For recruiters who share resumes widely and protect candidate details.',
    featuresDescription: 'Includes Standard, plus:',
    features: [
      { text: 'Resume redaction' },
      { text: 'Contact detail redaction' },
      { text: 'Custom keyword redaction' },
    ],
  },
  {
    planName: 'Agency',
    monthlyPrice: '$19',
    annualMonthlyPrice: '$19',
    priceUnit: 'per user / month',
    targetUser: 'Recruiting Agencies',
    url: '/signup?plan=team',
    linkLabel: 'Start your free 14-day trial',
    description:
      'One template, one brand — your whole team produces consistent resumes.',
    featuresDescription: 'Includes Pro, plus:',
    features: [
      { text: 'Invite as many recruiters as you need' },
      { text: 'One shared branding template' },
      { text: 'Owner and admin roles' },
      { text: 'One bill for the whole team' },
    ],
  },
]
